import { always, cond, head, isNil, keys, pickBy, pipe } from 'ramda';

import * as constants from './constants';

export const filterGamesFeatures = (games = []) => {
    const filteredGames = games.reduce((memo, game) => {
        const { gameCode } = game;

        const gameStudio = getGameStudio(game);
        const volatility = getGameVolatility(game);

        memo[gameCode] = {
            volatility,
            gameStudio,
            fsb: false,
            goldenChips: false,
            wilds: false
        };

        return memo;
    }, {});

    const gamesFromMap = getGamesFromMap(filteredGames);

    return { ...filteredGames, ...gamesFromMap };
};

export const getGameVolatility = (game) => {
    const { payOutScore } = game;

    return cond([
        [score => isNil(score) || score === -1, always(undefined)],
        [score => score < 5, always('very-low')],
        [score => score === 5, always('low')],
        [score => score === 6 || score === 7, always('medium')],
        [score => score > 7, always('high')]
    ])(payOutScore);
};

export const getGameStudio = (game) => {
    const { gameStudio } = game;

    return pipe(
        pickBy(gameStudioValues => gameStudioValues.includes(gameStudio)),
        keys,
        head
    )(constants.GAME_STUDIOS_MAP);
};

export const getGamesFromMap = (filteredGames) => {
    const gameCodes = Object.keys(constants.GAME_CODES_MAP);

    return gameCodes.reduce((memo, gameCode) => {
        const game = filteredGames[constants.GAME_CODES_MAP[gameCode]];

        return game ? { ...memo, [gameCode]: game } : memo;
    }, {});
};
